export default "__VITE_ASSET__ebeb55ab__"